import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzHeading } from '../../../components';

const Filters = ({ MutualfundFilter, setToggle, toggle, checkedItems, handleCheckBox, hanldeOnFilter }) => {

    return (

        <Container fluid className='p-0'>
            <Row className='g-0 py-4'>
                <Col className='d-flex justify-content-start'>
                    <BzHeading className='font-medium font-size6 color-text'>Filters</BzHeading>
                </Col>
                <Col md={1} className='d-flex justify-content-end'>
                    <div className='mf-filter-background bdr-radius-5 p-2'>
                        <div className='icon-20 icon-searchfilter icon-dark' onClick={hanldeOnFilter}>&nbsp;</div> {/* on click apply class - mf-left-section-collapse */}
                    </div>
                </Col>
            </Row>
            <Row className='g-0'>
                <Col>
                    {
                        MutualfundFilter?.map((item, index) =>
                            <div key={index}>
                                <Row className='g-0 pb-4'>
                                    <Col md={11} className='d-flex justify-content-start align-items-center'>
                                        <div className='d-flex align-items-center'>
                                            <div className='font-regular font-size4 color-subtext'>{item.title}</div>
                                            <div className='d-flex align-items-center ms-2'>
                                                <div className='allocate-dot blue-allocation'>&nbsp;</div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <div className='icon-10 icon-arrowdown icon-grey' onClick={() => toggle === index ? setToggle(null) : setToggle(index)}>&nbsp;</div>  {/* set conditional classes - icon-arrowdown and icon-arrowup */}
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    {toggle === index &&
                                        <Col className='bdr-btm pb-2 mb-3 mf-filter-scroll'>
                                            {item.subNav.map((subItem, index) => {
                                                return (<Row key={index} className='g-0 pt-2 pb-1 form-check'>
                                                    <Col>
                                                        <input className='form-check-input' type="checkbox" name={subItem.title} value={subItem.title} onChange={handleCheckBox} />
                                                    </Col>
                                                    <Col>
                                                        <div className='form-check-label font-regular font-size2 color-subtext'>{subItem.title}</div>
                                                    </Col>
                                                </Row>);
                                            })}
                                        </Col>
                                    }
                                </Row>
                            </div>
                        )
                    }
                </Col>
            </Row>
        </Container>

    );
};

export default memo(Filters);
